
<script>import Loader from '/app/components/Loader.html'
import { tween } from 'svelte-extras'
import { navItems, navigate, checkState } from '/helpers/list-helpers'

export default {

	data() {
		return {
			pagesize: 10
		}
	},

	computed: {
		filteredItems: (items, tag) => {
			// filter, truncate, and sort
			if (tag) {
				items = _.filter(items, item => {
					const lowerTags = _.map(item.tags, item => item.toLowerCase())
					return lowerTags.indexOf(tag.toLowerCase()) > -1
				})
			}
			items = _.map(items, item => {
				if (item.summary && item.summary.length > 200) {
					const pieces = item.summary.slice(0, 200).split(' ')
					pieces.pop()
					item.summary = pieces.join(' ') + ' . . .'
				}
				return item
			})
			// return items
			return _.orderBy(items, 'timestamp', 'desc')
		},
		paginatedItems: (filteredItems, page, pagesize) => {
			const start = (page - 1) * pagesize
			filteredItems = filteredItems.slice(start, start + pagesize)
			return filteredItems
		},
		navRange: (filteredItems, pagesize) => _.range(1, (filteredItems.length / pagesize) + 1),
		navItems: (filteredItems, page, navRange) => navItems(filteredItems, page, navRange),
	},

	oncreate() {

		// just some simple state management
		this.observe('tag', tag => this.checkState('tag', tag, ''))
		this.observe('page', page => this.checkState('page', page, 1))

		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => this.set({ items: json }))
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))

		// I hate this indirection, but it works...
		this.observe('yPosMirror', yPos => {
			this.set({ yPos })
		}, { init: false })
	},

	components: {
		Loader,
	},

	methods: {
		tween,
		navigate,
		checkState,
	},

}

</script><:Window bind:scrollY="yPos"/>{{#if tag}}
<div class="listing-toolbar fullwidth">
  <div class="wrap">
    <h2 class="h6 results">Results For: {{tag}}</h2>
    <button class="button" on:click="set({ page: 1, tag: '' })" aria-label="Load all news">All News</button>
  </div>
</div>{{/if}}
<div class="news-list media-objects block" ref:list>
  <div class="list">{{#if paginatedItems.length}}{{#each paginatedItems as item}}
    <div class="media-object stack-for-small">
      <div class="img media-object-section">{{#if item.image}}<img src="{{item.image}}" alt="{{item.imageAlt}}">{{else}}<img src="https://dummyimage.com/333x187/f2f3f2/f2f3f2.png" aria-hidden="true" alt="">{{/if}}
      </div>
      <div class="content media-object-section">
        <div class="date">{{item.timestampFormatted}}</div>
        <h2 class="h6 title"><a href="{{item.url}}">{{item.title}}</a></h2>
        <div class="body">{{item.summary}}</div>
      </div>
    </div>{{/each}}{{else}}
    <Loader></Loader>{{/if}}
  </div>{{#if navItems.length > 1 && paginatedItems.length}}
  <nav class="list-navigation" role="navigation" aria-label="News list pagination">
    <ul class="pagination">{{#if page <= 1}}
      <li class="pagination-previous disabled"><span class="show-for-sr">Previous page</span></li>{{else}}
      <li class="pagination-previous"><a on:click="navigate(event, 'previous')" href="/" aria-label="Previous page"><span class="show-for-sr">Previous page</span></a></li>{{/if}}{{#each navItems as item}}{{#if item.on}}
      <li class="current"><span class="show-for-sr">You're on page </span>{{item.value}}</li>{{elseif item.etc}}
      <li class="ellipsis" aria-hidden="true"></li>{{else}}
      <li><a on:click="navigate(event, item.value)" href="/" aria-label="Page {{item.value}}">{{item.value}}</a></li>{{/if}}{{/each}}{{#if page >= navRange.length}}
      <li class="pagination-next disabled"><span class="show-for-sr">Next page</span></li>{{else}}
      <li class="pagination-next"><a on:click="navigate(event, 'next')" href="/" aria-label="Next page"><span class="show-for-sr">Next page</span></a></li>{{/if}}
    </ul>
  </nav>{{/if}}
</div>